function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMccAirlines = function SvgMccAirlines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.352 3.268A1 1 0 0 1 13.316 2h4.066a1 1 0 0 1 .894.553L25 16h10a3 3 0 0 1 0 6H25l-6.724 13.447a1 1 0 0 1-.894.553h-4.066a1 1 0 0 1-.964-1.268L15.89 22H9.667l-1.439 4.316a1 1 0 0 1-.949.684H3.387a1 1 0 0 1-.948-1.316L4.667 19l-2.228-6.684A1 1 0 0 1 3.387 11H7.28a1 1 0 0 1 .949.684L9.667 16h6.222L12.352 3.268Z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgMccAirlines;